class DeferredMedia extends HTMLElement {
    constructor() {
        super(), this.querySelector('[id^="Deferred-Poster-"]') && (this.querySelector("span.deferred-media__poster-button") ? this.querySelector('[id^="Deferred-Poster-"]').addEventListener("click", this.loadContent.bind(this)) : this.loadContent())
    }
    loadContent() {
        this.getAttribute("loaded") || (this.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(!0)), this.setAttribute("loaded", !0), this.querySelector("span.deferred-media__poster-button") && (this.querySelector("span.deferred-media__poster-button").style.display = "none", 0 < this.closest(".swiper.swiper-initialized").length && (this.closest(".swiper.swiper-initialized").swiper.allowTouchMove = !1)), theme.utils.pauseAllMedia())
    }
}
class ModalDialog extends HTMLElement {
    constructor() {
        super(), this.querySelector('[id^="ModalClose-"]') && this.querySelector('[id^="ModalClose-"]').addEventListener("click", this.hide.bind(this)), this.addEventListener("click", e => {
            "MODAL-DIALOG" === e.target.nodeName && this.hide()
        })
    }
    show(e) {
        this.openedBy = e, document.querySelector("html").classList.add("overflow-hidden"), this.setAttribute("open", ""), this.querySelector(".template-popup") && this.querySelector(".template-popup").loadContent()
    }
    hide() {
        document.querySelector("html").classList.remove("overflow-hidden"), this.removeAttribute("open"), this.dispatchEvent(new CustomEvent("modalClose"))
    }
}
class DetailsDisclosure extends HTMLElement {
    constructor() {
        super(), this.mainDetailsToggle = this.querySelector("details"), this.addEventListener("keyup", this.onKeyUp), this.mainDetailsToggle.addEventListener("focusout", this.onFocusOut.bind(this))
    }
    onKeyUp(e) {
        if ("ESCAPE" === e.code.toUpperCase()) {
            const t = e.target.closest("details[open]");
            if (t) {
                const i = t.querySelector("summary");
                t.removeAttribute("open"), i.focus()
            }
        }
    }
    onFocusOut() {
        setTimeout(() => {
            this.contains(document.activeElement) || this.close()
        })
    }
    close() {
        this.mainDetailsToggle.removeAttribute("open")
    }
}
customElements.define("details-disclosure", DetailsDisclosure);
class ShareButton extends DetailsDisclosure {
    constructor() {
        super(), this.elements = {
            shareButton: this.querySelector("button"),
            successMessage: this.querySelector('[id^="ShareMessage"]'),
            urlInput: this.querySelector("input")
        }, navigator.canShare ? (this.mainDetailsToggle.removeAttribute("hidden"), this.mainDetailsToggle.addEventListener("toggle", this.toggleDetails.bind(this)), this.mainDetailsToggle.querySelector("button").addEventListener("click", this.copyToClipboard.bind(this))) : (this.mainDetailsToggle.setAttribute("hidden", ""), this.elements.shareButton.classList.remove("hidden"), this.elements.shareButton.addEventListener("click", () => {
            navigator.share({
                url: document.location.href,
                title: document.title
            })
        }))
    }
    toggleDetails() {
        this.mainDetailsToggle.open || this.elements.successMessage.classList.add("hidden")
    }
    copyToClipboard() {
        navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
            this.elements.successMessage.classList.remove("hidden"), this.elements.successMessage.setAttribute("aria-hidden", !1), setTimeout(() => {
                this.elements.successMessage.setAttribute("aria-hidden", !0)
            }, 6e3)
        })
    }
}
customElements.define("share-button", ShareButton);
class QuantityInput extends HTMLElement {
    constructor() {
        super(), this.input = this.querySelector("input"), this.changeEvent = new Event("change", {
            bubbles: !0
        }), this.querySelectorAll("button").forEach(e => e.addEventListener("click", this.onButtonClick.bind(this)))
    }
    onButtonClick(e) {
        e.preventDefault();
        var t = this.input.value;
        "plus" === e.target.name ? this.input.stepUp() : this.input.stepDown(), t !== this.input.value && this.input.dispatchEvent(this.changeEvent)
    }
}
customElements.define("quantity-input", QuantityInput);
class PickupAvailability extends HTMLElement {
    constructor() {
        super(), this.hasAttribute("available") && (this.errorHtml = this.querySelector("template").content.firstElementChild.cloneNode(!0), this.onClickRefreshList = this.onClickRefreshList.bind(this), this.fetchAvailability(this.dataset.variantId))
    }
    fetchAvailability(e) {
        e = `${this.dataset.baseUrl}variants/${e}/?section_id=pickup-availability`;
        fetch(e).then(e => e.text()).then(e => {
            e = (new DOMParser).parseFromString(e, "text/html").querySelector(".shopify-section");
            this.renderPreview(e)
        }).catch(e => {
            this.querySelector(".btn--link") && this.querySelector(".btn--link").removeEventListener("click", this.onClickRefreshList), this.renderError()
        })
    }
    onClickRefreshList(e) {
        this.fetchAvailability(this.dataset.variantId)
    }
    renderError() {
        this.innerHTML = "", this.appendChild(this.errorHtml), this.querySelector(".btn--link").addEventListener("click", this.onClickRefreshList)
    }
    renderPreview(e) {
        const t = document.querySelector("pickup-availability-drawer");
        if (t && t.remove(), !e.querySelector("pickup-availability-preview")) return this.innerHTML = "", void this.removeAttribute("available");
        this.innerHTML = e.querySelector("pickup-availability-preview").outerHTML, this.setAttribute("available", ""), document.body.appendChild(e.querySelector("pickup-availability-drawer")), this.querySelector(".btn--link").addEventListener("click", e => {
            document.querySelector("pickup-availability-drawer").show(e.target)
        })
    }
}
customElements.define("pickup-availability", PickupAvailability);
class PickupAvailabilityDrawer extends HTMLElement {
    constructor() {
        super(), this.onBodyClick = this.handleBodyClick.bind(this), this.querySelector("button").addEventListener("click", () => {
            this.hide()
        }), this.addEventListener("keyup", () => {
            "ESCAPE" === event.code.toUpperCase() && this.hide()
        })
    }
    handleBodyClick(e) {
        const t = e.target;
        t == this || t.closest("pickup-availability-drawer") || "ShowPickupAvailabilityDrawer" == t.id || this.hide()
    }
    hide() {
        this.removeAttribute("open"), document.body.removeEventListener("click", this.onBodyClick), this.scrollY = document.body.style.top, document.body.style.top = "", document.body.classList.remove("overflow-hidden-fixed"), window.scrollTo({
            left: 0,
            top: -1 * parseInt(this.scrollY || "0"),
            behavior: "instant"
        }), removeTrapFocus(this.focusElement)
    }
    show(e) {
        this.focusElement = e, this.setAttribute("open", ""), document.body.addEventListener("click", this.onBodyClick), document.body.style.top = `-${window.pageYOffset}px`, document.body.classList.add("overflow-hidden-fixed"), trapFocus(this)
    }
}
customElements.define("pickup-availability-drawer", PickupAvailabilityDrawer);
class VariantSelects extends HTMLElement {
    constructor() {
        super(), this.linkOptionsSelectors(), this.selectVariant(), this.addEventListener("change", this.onVariantChange), this.addEventListener("sliderChange", this.onSliderChange)
    }
    onVariantChange() {
        this.updateOptions(), this.updateMasterId(), this.toggleAddButton(!0, "", !1), this.updatePickupAvailability(), this.currentVariant ? (this.updateMedia(), this.updateURL(), this.updateVariantSelected(), this.renderProductInfo()) : (this.toggleAddButton(!0, "", !0), this.setUnavailable())
    }
    onSliderChange() {
        this.updateOptions(), this.updateMasterId(), this.toggleAddButton(!0, "", !1), this.updatePickupAvailability(), this.currentVariant ? (this.updateURL(), this.updateVariantSelected(), this.renderProductInfo()) : (this.toggleAddButton(!0, "", !0), this.setUnavailable())
    }
    updateOptions() {
        this.options = Array.from(this.querySelectorAll("[data-options-index]"), e => e.value)
    }
    updateMasterId() {
        this.currentVariant = this.getVariantData().find(e => !e.options.map((e, t) => this.options[t] === e).includes(!1))
    }
    linkOptionsSelectors() {
        let t = {};
        var i = this,
            e = this.getVariantData();
        let s = !1,
            r = !1;
        if (e) {
            for (var o = 0; o < e.length; o++) {
                var n, a = e[o];
                a.available && (t.root = t.root || [], t.root.push(a.option1), t.root = theme.utils.uniq(t.root), (null != a.option2 && 0 < this.querySelectorAll('[data-options-index="1"]').length || null != a.option3 && this.querySelectorAll('[data-options-index="2"]')) && (n = a.option1, s = !0, t[n] = t[n] || [], t[n].push(a.option2), t[n] = theme.utils.uniq(t[n])), null != a.option2 && 0 < this.querySelectorAll('[data-options-index="1"]').length && null != a.option3 && 0 < this.querySelectorAll('[data-options-index="2"]').length && (n = a.option1 + " / " + a.option2, r = !0, t[n] = t[n] || [], t[n].push(a.option3), t[n] = theme.utils.uniq(t[n])))
            }
            this.updateOptionsInSelector(0, t), (s || r) && this.updateOptionsInSelector(1, t), s && r && this.updateOptionsInSelector(2, t), (s || r) && this.querySelectorAll('[data-options-index="0"]').forEach(e => e.addEventListener("change", function () {
                return i.updateOptionsInSelector(1, t), s && r && i.updateOptionsInSelector(2, t), !0
            })), s && r && this.querySelectorAll('[data-options-index="1"]').forEach(e => e.addEventListener("change", function () {
                return i.updateOptionsInSelector(2, t), !0
            }))
        }
    }
    updateOptionsInSelector(e, t) {
        var i = 0 < this.querySelectorAll("select[data-options-index]").length;
        switch (e) {
            case 0:
                var s = "root";
                break;
            case 1:
                var s = (i ? this.querySelector('select[data-options-index="0"]') : this.querySelector('input[data-options-index="0"]:checked')).value;
                break;
            case 2:
                i ? (s = this.querySelector('select[data-options-index="0"]').value, s += " / " + this.querySelector('select[data-options-index="1"]').value) : (s = this.querySelector('input[data-options-index="0"]:checked').value, s += " / " + this.querySelector('input[data-options-index="1"]:checked').value)
        }
        var r = t[s];
        void 0 !== r && this.querySelectorAll(i ? 'select[data-options-index="' + e + '"] option' : 'input[data-options-index="' + e + '"]').forEach(e => {
            r.includes(e.value) ? e.removeAttribute("disabled", "disabled") : e.setAttribute("disabled", "disabled")
        })
    }
    updateMedia() {
        if (this.currentVariant && this.currentVariant.featured_media || this.currentVariant.featured_media) {
            const t = document.querySelector(`.product__media--main [data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`);
            if (t) {
                const i = document.querySelector(`#ProductsImages-${this.dataset.section} .product__media--main:not(.triple-slider-prev):not(.triple-slider-next)`);
                var e;
                780 <= document.documentElement.clientWidth ? "true" == i.getAttribute("data-active") ? (e = parseInt(t.getAttribute("data-index")), i.swiper.slideToLoop(e)) : window.setTimeout(() => {
                    var e = t.getBoundingClientRect().top + window.scrollY;
                    theme.utils.scrollToSmoothly(e, 400)
                }, 300) : "true" == i.getAttribute("datamob-active") && (e = parseInt(t.getAttribute("data-index")), i.swiper.slideToLoop(e))
            }
        }
    }
    updateURL() {
        this.currentVariant && window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`)
    }
    updateVariantSelected() {
        var i = this;
        const e = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
        e.forEach(e => {
            const t = e.querySelector('input[name="id"]');
            t && (t.value = i.currentVariant.id, t.dispatchEvent(new Event("change", {
                bubbles: !0
            })))
        })
    }
    updatePickupAvailability() {
        const e = document.querySelector("pickup-availability");
        e && (this.currentVariant && this.currentVariant.available ? e.fetchAvailability(this.currentVariant.id) : (e.removeAttribute("available"), e.innerHTML = ""))
    }
    renderProductInfo() {
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`).then(e => e.text()).then(e => {
            const t = (new DOMParser).parseFromString(e, "text/html");
            e = `price-${this.dataset.section}`;
            let i = document.getElementById(e),
                s = t.getElementById(e);
            s && i && (i.innerHTML = s.innerHTML), document.querySelector(`#price-${this.dataset.section}`) && (document.querySelector(`#price-${this.dataset.section} .price`).classList.remove("price-visibility-hidden"), document.querySelector(`#price-${this.dataset.section} .product__select_variant`).classList.add("hide")), 0 < document.querySelectorAll(".shopify-payment-button").length && document.querySelectorAll(".shopify-payment-button").forEach(e => {
                e.classList.remove("visibility-hidden")
            }), this.toggleAddButton(!this.currentVariant.available, theme.strings.soldOut), this.dispatchEvent(new CustomEvent("variantRendered")), e = `promotion-${this.dataset.section}`, i = document.getElementById(e), s = t.getElementById(e), s && i && (s.classList.contains("hide") ? i.classList.add("hide") : (i.innerHTML = s.innerHTML, i.classList.remove("hide")))
        })
    }
    toggleAddButton(e = !0, t, i) {
        const s = document.getElementById(`product-form-${this.dataset.section}`) ? document.getElementById(`product-form-${this.dataset.section}`).querySelector('[name="add"]') : "";
        s && (e ? (s.setAttribute("disabled", !0), t && (s.textContent = t)) : (s.removeAttribute("disabled"), s.textContent = theme.strings.addToCart))
    }
    setUnavailable() {
        const e = document.getElementById(`product-form-${this.dataset.section}`) ? document.getElementById(`product-form-${this.dataset.section}`).querySelector('[name="add"]') : "";
        e && (e.textContent = theme.strings.unavailable, document.querySelector(`#price-${this.dataset.section}`) && (document.querySelector(`#price-${this.dataset.section} .price`).classList.add("price-visibility-hidden"), document.querySelector(`#price-${this.dataset.section} .product__select_variant`).classList.remove("hide")), 0 < document.querySelectorAll(".shopify-payment-button").length && document.querySelectorAll(".shopify-payment-button").forEach(e => {
            e.classList.add("visibility-hidden")
        }))
    }
    getVariantData() {
        return this.variantData = this.variantData || JSON.parse(this.querySelector("[id^=VariantJson-").textContent), this.variantData
    }
    createVariantImage(e) {
        const n = {};
        return e.variants.forEach(r => {
            if (void 0 !== r.featured_image && null !== r.featured_image) {
                const o = r.featured_image.src.split("?")[0].replace(/http(s)?:/, "");
                n[o] = n[o] || {}, e.options.forEach((e, t) => {
                    var i = r.options[t],
                        s = `option-${t}`;
                    void 0 === n[o][s] ? n[o][s] = i : null !== (t = n[o][s]) && t !== i && (n[o][s] = null)
                })
            }
        }), n
    }
    selectVariant() {
        var e = this;
        const t = document.querySelector("[id^=ProductJson-");
        if (t) {
            const i = t.id.replace("ProductJson-", "shopify-section-");
            if (1 < document.querySelectorAll("#" + i + ' .product__media.image-container img[src*="/products/"]').length) {
                const s = JSON.parse(t.innerHTML),
                    r = this.createVariantImage(s);
                1 < s.variants.length && document.addEventListener("DOMContentLoaded", function () {
                    (!(780 <= document.documentElement.clientWidth) || "true" == document.querySelector("#" + i + " .product__media--main:not(.triple-slider-prev):not(.triple-slider-next)").getAttribute("data-active")) && e.listenChangeSlider(i, s, r)
                })
            }
        }
    }
    listenChangeSlider(r, o, n) {
        var a = this,
            e = document.querySelector("#" + r + " .product__media-wrapper.swiper-initialized:not(.triple-slider-prev):not(.triple-slider-next):not(.product__media--thumbnails)");
        e && e.swiper.on("activeIndexChange", function (e) {
            const {
                slides: t,
                activeIndex: i
            } = e, s = {};
            s.target = t[i].querySelector('img[src*="/products/"]'), void 0 !== s.target && a.updateVariant(s, r, o, n)
        })
    }
    updateVariant(e, t, i, n) {
        var a = this;
        const s = e.target.src.split("?")[0].replace(/http(s)?:/, "").split(".");
        var r = s.pop(),
            e = s.pop().replace(/_[a-zA-Z0-9@]+$/, "");
        const l = `${s.join(".")}.${e}.${r}`;
        let d;
        void 0 !== n[l] && (a.options = [], i.variants.forEach((e, i) => {
            var s = n[l][`option-${i}`];
            if (null != s) {
                const o = document.querySelectorAll("#" + t + " [data-options-index]");
                var r = o[i].options || o;
                for (let e, t = 0; e = r[t]; t += 1)
                    if (e.value === s) return a.options.push(s), o[i].options ? o[i].value = s : (o[t].checked = !0, o[t].dispatchEvent(new Event("change"))), void(d = o[i].closest(".variant-select"))
            }
        }), d.dispatchEvent(new CustomEvent("sliderChange")))
    }
}
customElements.define("variant-selects", VariantSelects);
class VariantRadios extends VariantSelects {
    constructor() {
        super()
    }
    updateOptions() {
        const e = Array.from(this.querySelectorAll("fieldset"));
        this.options = e.map(e => Array.from(e.querySelectorAll("input")).find(e => e.checked).value)
    }
}
customElements.define("variant-radios", VariantRadios);
class Magnify extends HTMLElement {
    constructor() {
        super();
        var e = this;
        780 <= document.documentElement.clientWidth && e.magnify(), window.on("resize", theme.utils.debounce(300, function () {
            780 <= document.documentElement.clientWidth ? e.magnify() : e.removeMagnify()
        }))
    }
    magnify() {
        var t, i = this,
            s = this.querySelector("img");
        null !== s && (this.querySelector(".magnify__large-img") ? t = this.querySelector(".magnify__large-img") : ((t = document.createElement("div")).classList.add("magnify__large-img"), t.style.backgroundImage = "url(" + s.getAttribute("src").replace("width=550", "width=2000") + ")"), i.querySelector(".image-container").appendChild(t), this.addEventListener("mousemove", function (e) {
            i.zoom(e, s, t)
        }, !1))
    }
    removeMagnify() {
        this.removeEventListener("mousemove", function (e) {
            self.zoom(e, Img, largeImg)
        }, !1)
    }
    zoom(e, t, i) {
        let s = t,
            r = i,
            o = r.style,
            n = (this.getBoundingClientRect(), e.offsetX),
            a = e.offsetY,
            l = s.width,
            d = s.height,
            c = n / l * 100,
            u = a / d * 100;
        .01 * l < n && (c += .15 * c), .01 * d <= a && (u += .15 * u), o.backgroundPositionX = c + "%", o.backgroundPositionY = u + "%", o.left = n - 50 + "px", o.top = a - 50 + "px"
    }
}
customElements.define("image-magnify", Magnify);
class ProductModal extends ModalDialog {
    constructor() {
        super()
    }
    hide() {
        super.hide(), super.querySelector(".product__media-wrapper.swiper-initialized") && super.querySelector(".product__media-wrapper").swiper.destroy(), super.querySelector(".product-media-modal__content").innerHTML = "", theme.utils.pauseAllMedia()
    }
    show(e) {
        super.show(e), this.loadContent(), this.showActiveMedia()
    }
    loadContent() {
        var e = super.closest(".product__left").querySelector(".product__media-wrapper");
        e.classList.contains("triple-slider-prev") && (e = e.closest(".triple-slider")), super.querySelector(".product-media-modal__content").innerHTML = "", super.querySelector(".product-media-modal__content").appendChild(e.cloneNode(!0)), super.querySelectorAll('.product__media.image-container img[src*="/products/"]').forEach(e => {
            var t = e.getAttribute("src").replace("width=550", "width=2800 2800w");
            e.setAttribute("srcset", e.getAttribute("srcset") + t), e.setAttribute("sizes", e.getAttribute("srcset").replace("50vw", "100vw"))
        })
    }
    showActiveMedia() {
        var e, t = this.openedBy.closest("modal-opener").querySelector("[data-media-id]").getAttribute("data-media-id");
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${t}"])`).forEach(e => {
            e.classList.remove("active")
        });
        const i = super.querySelector(".product__media-wrapper:not(.triple-slider-prev):not(.triple-slider-next)");
        if (780 <= document.documentElement.clientWidth)
            if ("true" == i.getAttribute("data-active")) {
                i.classList.contains("triple-slider-main") && (e = i.closest(".triple-slider"), i.classList.remove("triple-slider-main"), e.querySelector(".triple-slider-prev").remove(), e.querySelector(".triple-slider-next").remove()), new theme.Swiper_Slider(i);
                var s = parseInt(i.querySelector(`[data-media-id="${this.dataset.section}-${t}"]`).getAttribute("data-index"));
                i.swiper.slideTo(s)
            } else {
                const r = super.querySelector(`[data-media-id="${t}"]`);
                r.classList.add("active"), r.scrollIntoView()
            }
        else {
            i.classList.contains("triple-slider-main") && (e = i.closest(".triple-slider"), i.classList.remove("triple-slider-main"), e.querySelector(".triple-slider-prev").remove(), e.querySelector(".triple-slider-next").remove()), new theme.Swiper_Slider(i);
            t = parseInt(i.querySelector(`[data-media-id="${this.dataset.section}-${t}"]`).getAttribute("data-index"));
            i.swiper.slideTo(t)
        }
    }
}
customElements.define("product-modal", ProductModal);
class ProductModel extends DeferredMedia {
    constructor() {
        super()
    }
    loadContent() {
        super.loadContent(), Shopify.loadFeatures([{
            name: "model-viewer-ui",
            version: "1.0",
            onLoad: this.setupModelViewerUI.bind(this)
        }])
    }
    setupModelViewerUI(e) {
        var t, i;
        e || (t = (this.querySelector(".shopify-model-viewer-ui") && (this.querySelector(".shopify-model-viewer-ui").remove(), t = this.querySelector("template").content.firstElementChild.cloneNode(!0), this.appendChild(t)), this.querySelector("model-viewer")), this.modelViewerUI = new Shopify.ModelViewerUI(t), this.closest(".swiper.swiper-initialized") && (i = this.closest(".swiper.swiper-initialized"), this.closest(".swiper-slide-active") && (i.swiper.allowTouchMove = !1), t.addEventListener("shopify_model_viewer_ui_toggle_play", function () {
            this.closest(".swiper-slide-active") && (i.swiper.allowTouchMove = !1)
        }), t.addEventListener("shopify_model_viewer_ui_toggle_pause", function () {
            this.closest(".swiper-slide-active") && (i.swiper.allowTouchMove = !0)
        })))
    }
}
customElements.define("product-model", ProductModel), document.querySelectorAll(".product__media-item a").forEach(e => {
    e.addEventListener("click", function (e) {
        return e.preventDefault(), !1
    })
}), window.ProductModel = {
    loadShopifyXR() {
        Shopify.loadFeatures([{
            name: "shopify-xr",
            version: "1.0",
            onLoad: this.setupShopifyXR.bind(this)
        }])
    },
    setupShopifyXR(e) {
        e || (window.ShopifyXR ? (document.querySelectorAll('[id^="ModelJson-"]').forEach(e => {
            window.ShopifyXR.addModels(JSON.parse(e.textContent)), e.remove()
        }), window.ShopifyXR.setupXRElements()) : document.addEventListener("shopify_xr_initialized", () => this.setupShopifyXR()))
    }
}, window.addEventListener("DOMContentLoaded", () => {
    window.ProductModel && window.ProductModel.loadShopifyXR()
});
class ProductThumbnails extends HTMLElement {
    constructor() {
        super();
        var t = this;
        window.addEventListener("DOMContentLoaded", () => {
            t.init()
        }), document.addEventListener("shopify:section:load", e => {
            t.closest(`#${e.target.id}`) && t.init()
        })
    }
    init() {
        var t = this;
        this.swiper && (this.closest(".product__left").querySelectorAll(".product__media--main:not(.triple-slider-prev):not(.triple-slider-next)").forEach(e => {
            e.swiper.thumbs.swiper = this.swiper, e.swiper.thumbs.init(), e.swiper.on("activeIndexChange", function (e) {
                var {
                    activeIndex: e
                } = e;
                t.swiper.slideTo(e)
            })
        }), 780 < document.documentElement.clientWidth && this.swiper.slides.length < 5 && "vertical" != this.swiper.dataset.direction && this.querySelector(".swiper-wrapper").classList.add("flex-justify--center"))
    }
}
customElements.define("product-thumbnails", ProductThumbnails);
class StickyATC extends HTMLElement {
    constructor() {
        super();
        var e = this,
            t = !1,
            i = this.closest(".product-section").querySelector("product-form .product-form__submit");
        (t = i && !i.getAttribute("disabled") ? !0 : t) && (this.visible(), window.addEventListener("scroll", theme.utils.throttle(function () {
            e.visible()
        }, 200)), window.addEventListener("resize", theme.utils.throttle(function () {
            e.visible()
        }, 200)))
    }
    visible() {
        var e = this.closest(".product-section").querySelector("product-form .product-form__submit"),
            t = document.querySelector("footer"),
            i = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
        e && (!this.classList.contains("mu--hide") && 780 < document.documentElement.clientWidth || !this.classList.contains("s--hide") && document.documentElement.clientWidth <= 779) && (theme.utils.isInViewport(e) || i < theme.utils.offset(e).top + e.getBoundingClientRect().height || 0 == i ? this.classList.contains("active") && (this.classList.remove("active"), t.style.marginBottom = "") : this.classList.contains("active") || (this.classList.add("active"), t.style.marginBottom = this.getBoundingClientRect().height + "px"))
    }
}
customElements.define("sticky-atc", StickyATC);